// extracted by mini-css-extract-plugin
export default {"inputWrapper":"styles_inputWrapper__qJGhx","input":"styles_input__up9uJ"};